export var SubmissionTrackingStatus = /*#__PURE__*/ function(SubmissionTrackingStatus) {
    SubmissionTrackingStatus["Submitted"] = "true";
    SubmissionTrackingStatus["Failed"] = "false";
    return SubmissionTrackingStatus;
}({});
